import { useState } from '#app';
export const usePaywallModal = () => {
  const isPaywallOpen = useState('ft_paywall_open', () => false);
  const paywallFormats = useState('ft_paywall_formats', () => ['DST','PES','EXP','JEF','VP3','HUS','XXX','EMD']);
  const openPaywall = (formats) => { if (formats) paywallFormats.value = formats; isPaywallOpen.value = true; };
  const closePaywall = () => { isPaywallOpen.value = false; };
  return { isPaywallOpen, paywallFormats, openPaywall, closePaywall };
};
